import CancelPlanModalView from './CancelPlanModal.View';

const CancelPlanModal = (props: { open: boolean; onClose: () => void; onAccept: () => void }) => (
  <CancelPlanModalView {...props} />
);

export default CancelPlanModal;
